export const ENVIRONMENT = 'environment';
export const LIFE_STYLE = 'lifeStyle';
export const MEDICAL_HISTORY = 'medicalHistory';

export type QuestionnaireGroupName = typeof ENVIRONMENT | typeof LIFE_STYLE | typeof MEDICAL_HISTORY;
